import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PlusIconSvg } from '../../../../lib/icons';
import { Button } from '../../../../lib/components/atomic/button';

export const AddButton: FC<{
  onClick: () => void;
  disabled?: boolean;
  text?: string;
  startIcon?: ReactNode;
}> = ({ onClick, disabled = false, text }) => {
  const { t } = useTranslation();
  return (
    <Button onClick={onClick} disabled={disabled}>
      <PlusIconSvg />
      {text ?? t('template:ADD')}
    </Button>
  );
};
